const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2022 - 2024",
    title: "Diploma in Computer Science",
    desc: "Graduated with a credit from Riara University. Completed courses in Data Structures & Algorithms, Databases (SQL), Object-Oriented Programming (Java/C++), Linux, Statistics, Operating Systems, and Web Development. Final project involved building a web-based inventory management system.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2024 - Present",
    title: "Bachelor's Degree in Computer Science",
    desc: "Currently pursuing a degree in Computer Science at The Co-operative University of Kenya, focusing on advanced software development, data analytics, and information security.",
  },
  {
    id: 3,
    category: "certification",
    icon: "icon-certificate",
    year: "2024",
    title: "AWS Certified Cloud Practitioner",
    desc: "Earned the AWS Certified Cloud Practitioner certification, demonstrating foundational knowledge of cloud computing and AWS services.",
  },
  {
    id: 4,
    category: "education",
    icon: "icon-graduation",
    year: "2024",
    title: "AWS re/Start Program",
    desc: "Graduated from the AWS re/Start program under Emobilis and AWS Ajira. Hands-on labs covered cloud computing, identity and access management (IAM), serverless architectures, databases, and networking.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "January 2024 - April 2024",
    title: "Software Engineering Intern",
    desc: "Contributed to backend and frontend development at Flash Credit Africa. Enhanced loan application processes using C# .NET, Svelte, and TypeScript. Designed scalable solutions with Azure services and optimized Cosmos DB performance.",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "March 2024 - April 2024",
    title: "Web Development Intern",
    desc: "Collaborated on multiple web applications at Oasis Infobyte, implementing authentication systems and user interfaces. Proficient in the MERN stack (MongoDB, Express.js, React.js, Node.js) and deployed applications using cloud hosting platforms.",
  },
  {
    id: 7,
    category: "projects",
    icon: "icon-project",
    year: "2023",
    title: "Art Gallery Web Application",
    desc: "Developed a web application for buying and selling art. Features included user authentication, admin dashboards, payment gateways, and artist request management. Built with React.js, Node.js, Express.js, and MongoDB.",
  },
  {
    id: 8,
    category: "projects",
    icon: "icon-project",
    year: "2023",
    title: "Restaurant Food Ordering Website",
    desc: "Created a website for food ordering with interactive menu displays, secure payment integration, and admin dashboards for order management. Built using React.js, Node.js, Express.js, and MongoDB. Enhanced user experience with responsive design.",
  },
  {
    id: 9,
    category: "projects",
    icon: "icon-project",
    year: "2024",
    title: "S.O.Odingo & Co. Advocates Website",
    desc: "Developed a professional website for S.O.Odingo & Co. Advocates using WordPress. Integrated service pages, appointment booking, and a blog section to enhance client engagement.",
  },
  {
    id: 10,
    category: "projects",
    icon: "icon-project",
    year: "2024",
    title: "Watama Advocates Website",
    desc: "Built a responsive WordPress site for Watama Advocates, focusing on showcasing legal services, SEO optimization, and a streamlined user interface.",
  },
];

export default Data;
